export default {
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    view: 'Anzeigen',
    back: 'Zurück',
    close: 'Schließen',
    add: 'Hinzufügen',
    send: 'Senden',
    sending: 'Senden...',
    saving: 'Speichern...',
    loading: 'Laden...',
    search: 'Suchen',
    update: 'Aktualisieren',
    create: 'Erstellen',
    creating: 'Erstellen...',
    transfer: 'Übertragen',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    ok: 'Verstanden',
    name: 'Name',
    username: 'Benutzername',
    password: 'Passwort',
    email: 'E-Mail',
    date: 'Datum',
    status: 'Status',
    type: 'Typ',
    quantity: 'Menge',
    description: 'Beschreibung',
    project: 'Projekt',
    task: 'Aufgabe',
    logout: 'Abmelden',
    notifications: 'Benachrichtigungen',
    settings: 'Einstellungen',
    draft: 'Entwurf',
    sent: 'Gesendet',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    priority: 'Priorität',
    language: 'Sprache',
    yes: 'Ja',
    no: 'Nein',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    required: 'Pflichtfeld',
    optional: 'Optional',
    all: 'Alle',
    none: 'Keine',
    upload: 'Datei hochladen',
    download: 'Herunterladen',
    print: 'Drucken',
    actions: 'Aktionen',
    details: 'Details',
    filters: 'Filter',
    results: 'Ergebnisse',
    noResults: 'Keine Ergebnisse gefunden',
    total: 'Gesamt',
    of: 'von',
    verified: 'verifiziert',
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
  },

  auth: {
    login: 'Anmelden',
    loginTitle: 'Bei Ihrem Konto anmelden',
    logout: 'Abmelden',
    register: 'Registrieren',
    forgotPassword: 'Passwort vergessen?',
    resetPassword: 'Passwort zurücksetzen',
    usernameOrEmail: 'Benutzername oder E-Mail',
    enterPassword: 'Passwort eingeben',
    enterUsername: 'Benutzernamen eingeben',
    loginError: 'Benutzername oder Passwort falsch.',
    sessionExpired: 'Sitzung abgelaufen. Bitte erneut anmelden.',
  },

  nav: {
    dashboard: 'Übersicht',
    overview: 'Überblick',
    documents: 'Dokumente',
    viewDocuments: 'Dokumente anzeigen',
    manageProjects: 'Projekte verwalten',
    viewProjects: 'Projekte anzeigen',
    manageUsers: 'Benutzer verwalten',
    viewUsers: 'Benutzer anzeigen',
    manageWarehouse: 'Lager verwalten',
    viewWarehouse: 'Lager anzeigen',
    manageMachinery: 'Maschinen verwalten',
    viewMachinery: 'Maschinen anzeigen',
    manageSystem: 'System verwalten',
    projects: 'Projekte',
    myProjects: 'Meine Projekte',
    myTasks: 'Meine Aufgaben',
    reports: 'Berichte',
    drawings: 'Zeichnungen',
    warehouse: 'Lager',
    checkStock: 'Bestand prüfen',
    requests: 'Anfragen',
    requestItem: 'Artikel anfordern',
    tickets: 'Tickets',
    messages: 'Nachrichten',
    adminMode: 'Administratormodus',
    standardMode: 'Standardmodus',
    analystMode: 'Analysemodus',
    createReport: 'Bericht erstellen',
    createReports: 'Bauberichte',
    dailyReport: 'Täglicher Baubericht',
    incidentReport: 'Vorfallsbericht',
    safetySection: 'Arbeitssicherheit',
    safetyDialog: 'Sicherheitsdialoge',
    workPermit: 'Kritische Arbeitserlaubnis',
    occurrenceReport: 'Vorkommnisbericht',
    settingsMenu: 'Einstellungen',
  },

  profile: {
    editProfile: 'Profil bearbeiten',
    displayName: 'Name',
    usernameLabel: 'Benutzername',
    passwordLabel: 'Passwort',
    changePassword: 'Passwort ändern',
    appearance: 'Erscheinungsbild',
    lightMode: 'Hellmodus',
    darkMode: 'Dunkelmodus',
    languageLabel: 'Sprache',
    cropTitle: 'Profilbild zuschneiden',
    cropUse: 'Diesen Bereich verwenden',
    zoom: 'Zoom',
    currentPassword: 'Aktuelles Passwort bestätigen',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    emailVerified: 'verifiziert',
    emailChange: 'Ändern',
    emailSendCode: 'Code senden',
    emailConfirm: 'Bestätigen',
    emailResend: '← Code erneut senden',
    emailCancelChange: 'Abbrechen',
    emailSending: 'Senden...',
    emailVerifying: 'Verifizieren...',
    emailHint: 'Code gesendet an {email}. Prüfen Sie Posteingang und Spam.',
    emailSuccess: 'E-Mail {email} erfolgreich verifiziert.',
    emailInvalidError: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    emailGenericError: 'Fehler beim Senden des Codes.',
    emailInvalidCode: 'Ungültiger Code.',
    passwordFillAll: 'Bitte alle Passwortfelder ausfüllen.',
    passwordWrong: 'Das aktuelle Passwort ist falsch.',
    passwordMismatch: 'Die Passwortbestätigung stimmt nicht überein.',
    saveFillAll: 'Name und Benutzername ausfüllen.',
    saveFinishPassword: 'Passwortänderung beenden oder abbrechen vor dem Speichern.',
    avatarAlt: 'Profil',
  },

  dashboard: {
    overview: 'Überblick',
    myProjects: 'Meine Projekte',
    myTasks: 'Meine Aufgaben',
    activeProjects: 'Aktive Projekte',
    completedTasks: 'Abgeschlossene Aufgaben',
    pendingTasks: 'Ausstehende Aufgaben',
    recentActivity: 'Letzte Aktivitäten',
    noProjects: 'Keine Projekte gefunden.',
    noTasks: 'Keine Aufgaben gefunden.',
    createProject: 'Projekt erstellen',
    projectName: 'Projektname',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
  },

  projects: {
    title: 'Projekte',
    newProject: 'Neues Projekt',
    projectName: 'Projektname',
    startDate: 'Beginn',
    endDate: 'Ende',
    progress: 'Fortschritt',
    team: 'Team',
    gantt: 'Zeitplan',
    files: 'Dateien',
    tickets: 'Tickets',
    warehouse: 'Lager',
    dds: 'Sicherheitsgespräch',
    reports: 'Berichte',
    noProjects: 'Keine Projekte.',
    deleteConfirm: 'Möchten Sie dieses Projekt wirklich löschen?',
  },

  tasks: {
    title: 'Aufgaben',
    newTask: 'Neue Aufgabe',
    taskName: 'Aufgabenname',
    assignee: 'Verantwortlich',
    dependencies: 'Abhängigkeiten',
    duration: 'Dauer (Tage)',
    startDate: 'Beginn',
    endDate: 'Ende',
    progress: 'Fortschritt',
    addProgress: 'Fortschritt erfassen',
    noTasks: 'Keine Aufgaben.',
    blocked: 'Blockiert',
    inProgress: 'In Bearbeitung',
    done: 'Abgeschlossen',
    deleteConfirm: 'Diese Aufgabe löschen?',
  },

  warehouse: {
    title: 'Lager',
    stock: 'Bestand',
    requestItem: 'Artikel anfordern',
    requests: 'Anfragen',
    addItem: 'Artikel hinzufügen',
    itemName: 'Artikelname',
    category: 'Kategorie',
    unit: 'Einheit',
    available: 'Verfügbar',
    reserved: 'Reserviert',
    transferItem: 'Artikel übertragen',
    reportDamage: 'Schaden melden',
    provideEquipment: 'Ausrüstung bereitstellen',
    noItems: 'Keine Artikel im Bestand.',
    noRequests: 'Keine Anfragen.',
    approveRequest: 'Anfrage genehmigen',
    rejectRequest: 'Anfrage ablehnen',
    requestStatus: {
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      rejected: 'Abgelehnt',
      delivered: 'Geliefert',
    },
  },

  safety: {
    title: 'Sicherheit',
    dds: 'Sicherheitsgespräch',
    ddsTitle: 'Täglicher Sicherheitsdialog',
    newDds: 'Neues Sicherheitsgespräch',
    occurrences: 'Vorfälle',
    permits: 'Genehmigungen',
    createDialog: 'Dialog erstellen',
    createOccurrence: 'Vorfall erfassen',
    createPermit: 'Genehmigung erstellen',
    topic: 'Thema',
    presenter: 'Präsentator',
    attendees: 'Teilnehmer',
    date: 'Datum',
    noSafety: 'Keine Sicherheitsaufzeichnungen.',
  },

  tickets: {
    title: 'Tickets',
    newTicket: 'Neues Ticket',
    subject: 'Betreff',
    category: 'Kategorie',
    openedBy: 'Geöffnet von',
    assignedTo: 'Zugewiesen an',
    openTickets: 'Offene Tickets',
    closedTickets: 'Geschlossene Tickets',
    noTickets: 'Keine Tickets.',
    status: {
      open: 'Offen',
      inProgress: 'In Bearbeitung',
      closed: 'Geschlossen',
    },
  },

  users: {
    title: 'Benutzer',
    newUser: 'Neuer Benutzer',
    role: 'Rolle',
    roles: {
      adminMaster: 'Master-Admin',
      adminObra: 'Bau-Admin',
      user: 'Benutzer',
    },
    noUsers: 'Keine Benutzer.',
    deleteConfirm: 'Diesen Benutzer löschen?',
    manageRoles: 'Rollen verwalten',
    manageUsers: 'Benutzerverwaltung',
    userList: 'Benutzerliste',
  },

  system: {
    title: 'Systemeinstellungen',
    siteName: 'Systemname',
    logo: 'Logo',
    loginBackground: 'Anmeldehintergrund',
    primaryColor: 'Primärfarbe',
    save: 'Einstellungen speichern',
    saved: 'Einstellungen gespeichert.',
  },

  reports: {
    title: 'Berichte',
    daily: 'Tagesbericht',
    incident: 'Vorfallsbericht',
    noReports: 'Keine Berichte.',
    createReport: 'Bericht erstellen',
    date: 'Datum',
    author: 'Autor',
    content: 'Inhalt',
  },

  machinery: {
    title: 'Schwere Maschinen',
    newMachine: 'Neues Gerät',
    machineName: 'Name',
    model: 'Modell',
    plate: 'Kennzeichen',
    status: 'Status',
    noMachinery: 'Keine Geräte.',
  },

  messenger: {
    title: 'Nachrichten',
    newMessage: 'Neue Nachricht',
    noMessages: 'Keine Nachrichten.',
    typeMessage: 'Nachricht eingeben...',
    send: 'Senden',
  },
}
